import type { AsyncResolverDeps } from "./types";

export type AsyncSourceName = "season";

export type AsyncResolver = (field: string, deps: AsyncResolverDeps) => Promise<string>;

const ASYNC_SOURCE_NAMES = ["season"] as const satisfies readonly AsyncSourceName[];

const hasTokenData = (v: unknown): v is { data?: { token?: string } } =>
  typeof v === "object" && v !== null && "data" in v;

const seasonResolver: AsyncResolver = async (field, { session }) => {
  if (field !== "token") {
    throw new Error(`Unknown season field: ${field}`);
  }
  const result = await session.api.integrations.proxy_read({
    integration: "Season",
    type: "partner-redirect-token",
  });
  const token = hasTokenData(result) ? result.data?.token : undefined;
  if (typeof token !== "string" || token.length === 0) {
    throw new Error("Season partner-redirect response did not include a token");
  }
  return token;
};

export const ASYNC_RESOLVERS: Record<AsyncSourceName, AsyncResolver> = {
  season: seasonResolver,
};

export const ASYNC_SOURCES: ReadonlySet<string> = new Set<AsyncSourceName>(ASYNC_SOURCE_NAMES);

export const isAsyncSource = (source: string): source is AsyncSourceName => ASYNC_SOURCES.has(source);
